import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ComunicacaoCliente } from '../../core/models/workflow.models';

@Component({
  selector: 'app-communication-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './communication-list.component.html',
  styleUrl: './communication-list.component.scss',
})
export class CommunicationListComponent {
  @Input({ required: true }) comunicacoes: ComunicacaoCliente[] = [];
}
